const FOCUSABLE =
    'button:not(:disabled), input:not(:disabled), textarea:not(:disabled), select:not(:disabled), [href], [tabindex]:not([tabindex="-1"])';
// The control fieldset stays disabled until the DM write settles, a few frames after the switch.
const FOCUS_RETRIES = 20;
const FOCUS_RETRY_MS = 50;

/** The control that opened a step, and its place among home's controls in case it is replaced. */
export interface TriggerMemory {
    element: HTMLElement;
    index: number;
}

function focusables(root: HTMLElement): HTMLElement[] {
    return [...root.querySelectorAll<HTMLElement>(FOCUSABLE)];
}

export function rememberTrigger(
    target: EventTarget,
    home: HTMLElement | null
): TriggerMemory | null {
    if (!home || !(target instanceof Element)) return null;
    const element = target.closest<HTMLElement>('button, [tabindex]');
    if (!element || !home.contains(element)) return null;
    return { element, index: focusables(home).indexOf(element) };
}

export function focusFirstIn(layer: HTMLElement): void {
    focusables(layer)[0]?.focus();
}

function tryFocus(memory: TriggerMemory | null, home: HTMLElement): boolean {
    if (home.closest('fieldset')?.disabled) return false;
    const candidates = focusables(home);
    if (candidates.length === 0) return false;
    const target =
        memory && memory.element.isConnected && candidates.includes(memory.element)
            ? memory.element
            : candidates[Math.min(Math.max(memory?.index ?? 0, 0), candidates.length - 1)];
    target.focus();
    return document.activeElement === target;
}

/** Back on home: the trigger, else whatever now sits in its place; retries while controls are disabled. */
export function focusWhenAble(memory: () => TriggerMemory | null, home: HTMLElement): void {
    let attempts = 0;
    const attempt = () => {
        if (tryFocus(memory(), home) || ++attempts >= FOCUS_RETRIES) return;
        window.setTimeout(attempt, FOCUS_RETRY_MS);
    };
    attempt();
}
